import { render, staticRenderFns } from "./CommissionModal.vue?vue&type=template&id=fef52b44"
import script from "./CommissionModal.vue?vue&type=script&lang=js"
export * from "./CommissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports